import { useMutation, useQueryClient } from '@tanstack/react-query';
import { bidKeys } from '@tempmee/awards';
import type { ISubmitBidFeedbackParams } from '../clients/SubmitBidFeedback';
import { submitBidFeedbackService } from '../services/SubmitBidFeedback';

export const useSubmitBidFeedback = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: ISubmitBidFeedbackParams) => submitBidFeedbackService(params),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: bidKeys.pendingFeedback() });
      // The gate is keyed by the (cycle, applicant) pair, not jobId — match
      // useEodBidGate's key so the submitted pair's gate is actually refreshed.
      queryClient.invalidateQueries({
        queryKey: [...bidKeys.all, 'eod-gate', variables.cycleId, variables.applicantUserId],
      });
    },
    meta: { skipGlobalErrorToaster: true },
  });
};
